module.exports = __webpack_public_path__ + "static/media/logo_telkom-light.2ce24177.png";